export default "__VITE_ASSET__BP6egF5S__"